export default "__VITE_ASSET__88c4b580__"